<template>
  <div id="experiences">
    <router-link :to="{ name: 'create-experience' }" class="btn btn-primary">Add Experience</router-link>
    <div class="experiences-list">
      <div v-for="exp in experiences" :key="exp.id" class="experience-item">
        <router-link
          :to="{ name: 'edit-experience', params: { id: exp.id} }"
          class="experience-edit-link"
        >
          <div
            class="thumbnail"
            :style="{ backgroundImage: `url(${exp.thumbnailUrl || images.picture})`, backgroundSize: exp.thumbnailUrl ? 'cover': null }"
          ></div>
          <div class="experience-title">{{exp.title}}</div>
        </router-link>
        <div class="tools">
          <div class="close-button" @click="() => onClickDeleteButton(exp)">
            <img :src="images.trash" />
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDeleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Delete Confirmation</v-card-title>
        <v-card-text>Are you sure for delete this item?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="deleteSelectedItem">Delete</v-btn>
          <v-btn text @click="closeDeleteDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import picture from "@/assets/images/picture.svg";
import trash from "@/assets/images/trash-bin.svg";
import { getUserId } from "@/services/UserService";

export default {
  name: "experiences",
  data() {
    return {
      images: {
        picture,
        trash
      },
      page: 1,
      experiences: [],
      selectedItem: null,
      showDeleteDialog: false
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      const userId = getUserId();
      this.$repo.exp
        .getExperiencesByUser(userId, {
          page: this.page
        })
        .then(result => {
          this.experiences = result.data;
          this.final = result.final;
        });
    },
    onClickDeleteButton(item) {
      this.showDeleteDialog = true;
      this.selectedItem = item;
    },
    deleteSelectedItem() {
      if (!this.selectedItem) return;

      this.$repo.exp
        .deleteExperience(this.selectedItem.id)
        .then(() => {
          this.closeDeleteDialog();
          this.$toasted.show("Deleted experience successfully.", {
            type: "success",
            duration: 3000,
            position: "bottom-right"
          });
          this.load();
        })
        .catch(err => {
          this.$toasted.show(err, {
            type: "error",
            duration: 3000,
            position: "bottom-right"
          });
        });
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.selectedItem = null;
    }
  }
};
</script>

<style lang="scss" scoped>
#experiences {
  padding: 50px 0;

  .experiences-list {
    margin: 50px 0;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: auto;
    grid-gap: 30px;

    @media screen and (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }

    .experience-item {
      width: 100%;
      background-color: #fff;
      padding: 15px;
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
      margin-bottom: 20px;
      margin-right: 1.5%;

      a {
        color: #000;
        text-decoration: none;
        display: block;
        width: 100%;
      }

      .experience-title {
        width: 50%;
        padding: 20px 0 10px;
        text-align: center;
        width: 100%;
      }

      .thumbnail {
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        height: 240px;
      }

      .tools {
        display: flex;
        justify-content: flex-end;
        width: 100%;

        & > * {
          margin-left: 10px;
        }
      }

      .close-button {
        cursor: pointer;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>

